/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { FormApi } from 'final-form'
import { Checkbox } from 'components/Checkbox'
import { DropzoneField } from 'components/DropzoneField'
import { InputField } from 'components/Input'
import { validateRequired, validateRequiredDefaultHtml } from 'utils/validation'
import { EditorField } from 'components/Editor'
import { AdditionalFieldsConfig, DROPZONE_OPTIONS, FormState } from '../consts'
import * as commonClasses from '../commonStyles'
import * as classes from './styles'

export type AdditionalFieldProps = {
  config: AdditionalFieldsConfig['otherFields'][number]
  values: FormState
  form: FormApi<FormState, Partial<FormState>>
}

export const AdditionalField: FC<AdditionalFieldProps> = ({ config, values, form }) => {
  const { key, isNeedKey, label, placeholder, description, variant, filesLimit } = config
  const isNeedFormKey = isNeedKey as keyof FormState

  const renderField = () => {
    switch (variant) {
      case 'images':
        return (
          <DropzoneField
            name={key}
            label={label}
            validate={validateRequired}
            dropzoneOptions={DROPZONE_OPTIONS}
            options={{
              maxFiles: filesLimit ?? 1,
              sliceFromEnd: true,
            }}
            css={classes.field}
          />
        )
      case 'text':
        return (
          <InputField
            name={key}
            label={label}
            placeholder={placeholder}
            validate={validateRequired}
            css={classes.field}
            fullWidth
          />
        )
      case 'html':
        return (
          <div css={classes.field}>
            <EditorField
              name={key}
              type="default"
              label={label}
              placeholder={placeholder}
              validate={validateRequiredDefaultHtml}
              css={commonClasses.editor}
            />
          </div>
        )
    }
  }

  return (
    <div>
      <Checkbox
        label={`Do you need ${label}?`}
        checked={Boolean(values[isNeedFormKey])}
        onChange={(_, value) => form.change(isNeedFormKey, value)}
        css={classes.field}
      />
      {!!values[isNeedFormKey] && (
        <>
          {!!description && <div css={classes.description}>{description}</div>}
          {renderField()}
        </>
      )}
    </div>
  )
}
